<template>
  <v-app style=" background: none !important;">
    <router-view/>
  </v-app>
</template>

<script>
import '@/components/css/style.css'
export default {
  data () {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js'
    }
  },
  name: 'App'
  // created() {
  //   console.log(this.$route.query.state)
    
  // },
  // mounted () {
  // },
  // watch: {
  //   '$route.query.state' () {
  //     console.log(this.$route.query.state)
  //   }
  // },
  // methods: {
  // }
}
</script>


// WEBPACK FOOTER //
// src/App.vue